import { RootState } from '../../store/index'

type State = RootState['navigation']

export abstract class NavigationSlice {
  /**
   * Setter for currentPanel
   * @param state The state of the store
   * @param payload The payload for the function
   */
  public static cameraPostionUpdate(state: State, payload: number[]): void {
    state.cameraPosition = payload
  }
}

/**
 * The current camera position
 * @param state The state of the store
 * @returns Current position of the camera
 */
export const cameraPostion = (state: RootState): number[] => {
  return state.navigation.cameraPosition
}
